import { FC } from "react";
import { EmptyStateProps, EmptyStateSize } from "./empty-state.types";
import { Grid, Theme, useTheme } from "@mui/material";
import { Paragraph, ParagraphSmall } from "../typography";
import { Button } from "../button";
import { EmptyStateIcon } from "./empty-state-icon";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    maxWidth: 126,
    maxHeight: 96,
    marginBottom: theme.spacing(1.5)
  }
}));

export const EmptyState: FC<EmptyStateProps> = ({
  iconUrl,
  title,
  subtitle,
  size = EmptyStateSize.REGULAR,
  primaryButtonLabel,
  secondaryButtonLabel,
  primaryButtonOnClick,
  secondaryButtonOnClick
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Grid
      container
      alignItems="center"
      direction="column"
      my={size === EmptyStateSize.LARGE ? 13 : 2}
      px={size === EmptyStateSize.LARGE ? 17 : 2}
      width="100%"
    >
      {iconUrl ? (
        <img src={iconUrl} alt="emptyStateIcon" className={classes.icon} />
      ) : (
        <EmptyStateIcon
          sx={{
            color: theme.palette.secondary.main,
            marginBottom: theme.spacing(1.5),
            width: 126,
            height: 96
          }}
        />
      )}

      <Paragraph sx={{ color: theme.palette.text.primary, textAlign: "center" }} mb={0.5} mt={2}>
        {title}
      </Paragraph>
      <ParagraphSmall sx={{ color: theme.palette.text.secondary, textAlign: "center" }}>
        {subtitle}
      </ParagraphSmall>
      {((secondaryButtonLabel && secondaryButtonOnClick) ||
        (primaryButtonLabel && primaryButtonOnClick)) && (
        <Grid gap={1.5} container justifyContent="center" mt={2.5} mb={2}>
          {secondaryButtonLabel && secondaryButtonOnClick && (
            <Button onClick={secondaryButtonOnClick} variant="secondary">
              {secondaryButtonLabel}
            </Button>
          )}
          {primaryButtonLabel && primaryButtonOnClick && (
            <Button onClick={primaryButtonOnClick} variant="primary">
              {primaryButtonLabel}
            </Button>
          )}
        </Grid>
      )}
    </Grid>
  );
};
